import React from 'react'
import ReactDom from 'react-dom'

class Item extends React.Component {

  constructor(props) {
    super(props)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.currentFloor !== this.props.currentFloor
    || nextProps.displayCount !== this.props.displayCount
    || nextProps.floor !== this.props.floor
    || nextProps.unitCount !== this.props.unitCount
  }

  render() {
    let {
      currentFloor,
      displayCount,
      floor,
      unitCount
    } = this.props

    let classes = 'floor-vertical-item'
    classes += unitCount ? '' : ' deemphasize'
    classes += floor.value === currentFloor ? ' selected' : ''

    return (<tr
              className={classes}
              data-value={floor.value}
              onClick={this.props.onChange} >
              <td>
                <a href="#">
                  {floor.label}
                </a>
              </td>
              { displayCount ? (
              <td>
                <div>
                    <span style={{display: 'inline', fontSize: '0.75rem'}}>{unitCount}</span>
                    <span>{unitCount !== 1 ? 'units' : 'unit'}</span>
                </div>
              </td>
              ) : null}
            </tr>
    )
  }
}

Item.defaultProps = {
  currentFloor: null,
  displayCount: true,
  floor: null
}

export default Item
